import { render, staticRenderFns } from "./RsaConfigurazioneAttivitaDomiciliareListPage.vue?vue&type=template&id=95d054a8"
import script from "./RsaConfigurazioneAttivitaDomiciliareListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAttivitaDomiciliareListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports